import { produtoService } from '@/services/produtoService';

const getDefaultState = () => {
  return {
    produtos: [],
    isModified: false
  }
}

const state = getDefaultState();

const getters = {
  produtos: state => state.produtos.sort((a, b) => a.descricao > b.descricao ? 1 : -1),
  isProdutosModified: state => !!state.isModified
};

const actions = {
  async fetchProdutos({ commit }) {
    try {
      let response = await produtoService.getProdutos();
      commit('SET_PRODUTOS', response);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async fetchProdutosAPI({ commit }) {
    try {
      const response = await produtoService.getProdutosAPI();
      commit('SET_PRODUTOS', response);
      commit('SET_IS_PRODUTOS_MODIFIED', true);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  // async fetchProdutoUnidadesSaidaAPI({ commit }, produto) {
  //   try {
  //     const response = await produtoService.getProdutoUnidadesSaidaAPI(produto.id_produto);
  //     const unidades = process.env.NODE_ENV === 'production' ? response.data.result.Sql || [] : response.data.Sql || [];
  //     produto.unidadesSaida = unidades && unidades.length ? unidades : [];
  //     await produtoService.updateProduto(produto);
  //     commit('UPDATE_PRODUTO', produto);
  //     commit('SET_IS_PRODUTOS_MODIFIED', true);
  //   } catch (error) {
  //     console.log(error);
  //     commit('SHOW_SNACKBAR', { text: error, status: 'error' });
  //   }
  // },
};

const mutations = {
  CLEAR_PRODUTOS_STATE: state => Object.assign(state, getDefaultState()),
  SET_PRODUTOS: (state, produtos) => state.produtos = produtos,
  UPDATE_PRODUTO: (state, updProd) => {
    const index = state.produtos.findIndex(produto => produto.id_produto == updProd.id_produto);
    if (index !== -1) state.produtos.splice(index, 1, updProd);
  },
  SET_IS_PRODUTOS_MODIFIED: (state, isModified) => state.isModified = isModified
};

export default {
  state,
  getters,
  actions,
  mutations
}